module.exports = __webpack_public_path__ + "img/05.70385a6a.jpg";